
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.533 15.588c.307-.292.665-.588 1.089-.588H22a1 1 0 001-1v-1.586a1 1 0 00-.293-.707l-2.592-2.592a1 1 0 00-.26-.188l-1.644-.821A1 1 0 0017.764 8h-5.571a1 1 0 00-.372.072L7 10l-3.731.933a1 1 0 00-.465.263l-1.511 1.511a1 1 0 00-.293.707V14a1 1 0 001 1h.378c.424 0 .782.296 1.089.588.269.255.633.412 1.033.412.4 0 .764-.157 1.033-.412.307-.292.665-.588 1.089-.588h10.756c.424 0 .782.296 1.089.588.269.255.633.412 1.033.412.4 0 .764-.157 1.033-.412zM9.415 10.17l-.053.106a.5.5 0 00.447.724h3.8a.5.5 0 00.486-.379l.25-1A.5.5 0 0013.86 9h-1.764a.5.5 0 00-.185.036l-2.234.893a.5.5 0 00-.262.241zm6.49-.791l-.25 1a.5.5 0 00.485.621h3.36a.5.5 0 00.5-.5v-.191a.5.5 0 00-.276-.447l-1.618-.81A.5.5 0 0017.882 9H16.39a.5.5 0 00-.485.379z","fill":"currentColor"}})])
          )
        }
      }
    